export default "__VITE_ASSET__5mn36mrm__"